import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Store {
  constructor() {
    _defineProperty(this, "models", {});
  }
  add(type, model) {
    this.models[type] = model;
    return this;
  }
  extend(app, extension) {
    for (const type in this.models) {
      if (app.store.models[type]) {
        throw new Error("The model type \"".concat(type, "\" has already been registered with the class \"").concat(app.store.models[type].name, "\"."));
      }
      app.store.models[type] = this.models[type];
    }
  }
}
flarum.reg.add('core', 'common/extenders/Store', Store);